import { useEffect, useState } from 'react';
import { getSimpleIndicatorProjects } from '../../../../../api/indicatorApi';
import { getProjectsInPreparationPipelineCounts } from '../../../../../services/projectsInPreparationUtil';

const useProjectsInPreparationPipelineCounts = card => {
  const [pipelineCounts, setPipelineCounts] = useState({
    pipelineACount: card.data?.pipelineACount,
    pipelineBCount: card.data?.pipelineBCount,
  });

  useEffect(() => {
    if (card.indicatorKey !== 'PROJECTS_IN_PREPARATION') {
      return;
    }

    if (card.data?.pipelineACount !== undefined || card.data?.pipelineBCount !== undefined) {
      setPipelineCounts({
        pipelineACount: card.data?.pipelineACount,
        pipelineBCount: card.data?.pipelineBCount,
      });
      return;
    }

    let isMounted = true;

    const loadPipelineCounts = async () => {
      try {
        const projects = await getSimpleIndicatorProjects(card.id);

        if (!isMounted) {
          return;
        }

        setPipelineCounts(getProjectsInPreparationPipelineCounts(projects));
      } catch (error) {
        console.error('Error loading projects in preparation pipeline counts', error);
      }
    };

    loadPipelineCounts();

    return () => {
      isMounted = false;
    };
  }, [card.data?.pipelineACount, card.data?.pipelineBCount, card.id, card.indicatorKey]);

  return {
    pipelineACount: pipelineCounts.pipelineACount ?? '-',
    pipelineBCount: pipelineCounts.pipelineBCount ?? '-',
  };
};

export default useProjectsInPreparationPipelineCounts;
